import * as React from 'react';
import {
  StackItem,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { HealthMetricData } from '#components/charts/core/range-graph/utils/use-health-metric-values.ts';
import { DatumLegend } from '#pages/details2/components/datum-legend.tsx';
import { shapes } from '#components/charts/core/xychart/primitives/Shape.tsx';
import {
  DATE_FORMAT,
  useFormatDateByUserProfileLocation,
} from '@leagueplatform/web-common';
import { getHealthMetricDisplayValue } from '#utils/get-health-metric-display-value.ts';
import { getHealthMetricUnitDisplayValue } from '#utils/get-health-metric-unit-display-value.ts';
import { ChartTooltip } from './chart-tooltip';

type MultipleMeasurementsTooltipProps = {
  data: HealthMetricData;
};

export function MultipleMeasurementsTooltip({
  data,
}: MultipleMeasurementsTooltipProps) {
  const formatDateWithUserProfileLocation =
    useFormatDateByUserProfileLocation();

  return (
    <ChartTooltip>
      <StackLayout spacing="$half">
        {data.map((datum) => {
          const shape = shapes[datum.metric.data.order];
          const value = getHealthMetricDisplayValue(datum);
          const unit = getHealthMetricUnitDisplayValue(
            value,
            datum.metric.data.unit,
          );

          return (
            <StackItem>
              <DatumLegend
                size="small"
                shape={shape}
                name={datum.metric.data.name.toUpperCase()}
                value={value}
                unit={unit}
              />
            </StackItem>
          );
        })}
        <UtilityText size="eyebrow">
          {formatDateWithUserProfileLocation(data[0].timestamp, DATE_FORMAT)}
        </UtilityText>
      </StackLayout>
    </ChartTooltip>
  );
}
